import axios from "@/plugins/axios";

let url = "/api/v1/company/human-resource";

export default {
    getApplicants(data) {
        return axios.get(`${url}/applicants`, data).then((result) => result.data);
    },
    getBlacklist(data) {
        return axios.get(`${url}/blacklist`, data).then((result) => result.data);
    },
    getFavorites(data) {
        return axios.get(`${url}/favorites`, data).then((result) => result.data);
    },
    getRecruits(data) {
        return axios.get(`${url}/recruits`, data).then((result) => result.data);
    },
    getQualifiers(data) {
        return axios.get(`${url}/qualifiers`, data).then((result) => result.data);
    },
};
